import { gql } from '@apollo/client';

export const SEARCH_OPTION_QUERY = gql`
query getUserSearchOptions {
    getUserSearchOptions {
      offices {
        id
        name
      }
      roles {
        id
        name
      }
    }
  }
`;